module.exports = __webpack_public_path__ + "static/media/icon_print.bfe4565c.svg";